import { Link } from "react-router-dom";

const COLS = [
  {
    title: "Explore",
    links: [
      { label: "Our Vision", to: "/vision" },
      { label: "About William Martin", to: "/about" },
      { label: "What We Build", to: "/what-we-build" },
      { label: "AI on Country", to: "/ai-on-country" },
      { label: "Stewardship Intelligence", to: "/stewardship-intelligence" },
      { label: "Initiatives", to: "/initiatives" },
      { label: "Living Network", to: "/network" },
      { label: "Our Story", to: "/origins" },
    ],
  },
  {
    title: "Work With Us",
    links: [
      { label: "Partner With WisdomKeepers", to: "/partner" },
      { label: "Start a Conversation", to: "/partner" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#050806]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid md:grid-cols-2 gap-16">
          <div>
            <Link to="/" className="inline-flex items-center gap-4">
              <img src="/logo-badge-white.png" alt="" className="h-16 w-16 object-contain" />
              <img
                src="/wordmark-cream.png"
                alt="WisdomKeepers"
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="mt-6 max-w-md text-[#A8A5A1] leading-relaxed">
              Helping communities steward memory, culture and knowledge so future
              generations inherit more than information — they inherit understanding.
            </p>
            <div className="mt-8 space-y-2">
              <p className="wk-label mb-3">Get in touch</p>
              <a
                href="mailto:william@wisdomkeepers.com"
                data-testid="footer-email-link"
                className="block text-[#D8D4CE] hover:text-[#D4A373] transition-colors duration-300"
              >
                william@wisdomkeepers.com
              </a>
              <a
                href="tel:+61411798772"
                data-testid="footer-phone-link"
                className="block text-[#D8D4CE] hover:text-[#D4A373] transition-colors duration-300"
              >
                +614 117 98 772
              </a>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8">
            {COLS.map((col) => (
              <div key={col.title}>
                <p className="wk-label mb-5">{col.title}</p>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        to={l.to}
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-[#A8A5A1] hover:text-[#D4A373] transition-colors duration-300"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-[#A8A5A1]/70">
          <p>© {new Date().getFullYear()} WisdomKeepers. Stewardship, not ownership.</p>
          <p className="font-display italic text-base text-[#A8A5A1]">
            Technology is never the purpose. Stewardship is.
          </p>
        </div>
      </div>
    </footer>
  );
}
